import { render, staticRenderFns } from "./FormBoxEdit.vue?vue&type=template&id=0cfa13c4&scoped=true&"
import script from "./FormBoxEdit.vue?vue&type=script&lang=js&"
export * from "./FormBoxEdit.vue?vue&type=script&lang=js&"
import style0 from "./FormBoxEdit.vue?vue&type=style&index=0&id=0cfa13c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfa13c4",
  null
  
)

export default component.exports